<template>
  <div class="flood-template">
    <div class="card custom-yellow z-depth-0">
      <div class="card-content">
        <div class="step-title">
          Expected Impact Level
        </div>
        <p style="margin-bottom:12px">
          Consider the results of your home assessment. Use the <a href="#" helper-id="C002">Expected Impact Level Chart</a> to select the expected impact level from a flood event similar to the 2013
          Christmas Eve Trough.
        </p>
        <p>
          Apply your best judgement using information from the assessment, additional knowledge of your home and past experiences to select the most likely expected impact level for your home. Write a
          brief justification for your selection in the space provided.
        </p>
      </div>
    </div>

    <div class="card">
      <div class="card-content">
        <div class="step-title">Guidance</div>
        <div>
          <b>For homes constructed before the 2013 Christmas Eve Trough</b> <br />
          The impact your home experienced during the 2013 Christmas Eve Trough provides a good gauge of the impact you can expect in another similar 100-year flood if there have been no major changes
          to your community, land or house that would have increased or decreased your exposure or vulnerability. If changes have occurred, gauge the appropriate level of expected impact today based
          on those changes and explain these in your justification. The questions about exposure to flooding and the checklist of resiliency features provided should help you understand changes that
          would have a positive or negative effect on the expected impact level.
        </div>
        <div style="margin-top:12px;">
          <b>For homes constructed or acquired after the 2013 Christmas Eve Trough </b> <br />
          If your home was not constructed or you did not live in your home during the 2013 Christmas Eve Trough, interview close-by neighbours or past owners to understand the level of impact
          experienced and use the results of your home assessment to gauge how your house would be impacted by a similar event in the future.
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "floodSurveyFinal",
  mounted() {
    this.$_setupHelpers();
  },
  methods: {
    $_openModal() {
      this.$emit("openModal", true);
    },
    $_setupHelpers() {
      const helpers = this.$el.querySelectorAll("[helper-id]");

      if (helpers) {
        helpers.forEach((helperEl) => {
          helperEl.addEventListener("click", (event) => {
            event.preventDefault();
            const helperId = helperEl.getAttribute("helper-id");
            const styles = helperEl.getAttribute("helper-style");
            this.$store.dispatch("Helpers/setHelper_", { id: helperId, styles: styles ? styles : "" });
            /*  this.$store.dispatch("Helpers/setHelper", helperId); */
          });
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.custom-yellow {
  background: #fbd15e;
}
.step-title {
  font-size: 24px;
  i {
    line-height: 32px;
    margin-right: 8px;
  }
}
</style>
